<template>
  <div class="customer-types-container">
    <div v-for="customer_type in customerTypes" v-bind:key="customer_type.id">
      <div class="customer-type-container" v-bind:style="{ 'background-color': customer_type?.type_color?.hex_value }">
        <span class="customer-type-name">{{ customer_type.name }}</span>
      </div>
      <div v-for="(customer_sub_type, index) in subTypes(customer_type)" v-bind:key="customer_sub_type.id">
        <div class="customer-sub-type-container" v-if="index == 0" v-bind:style="{ 'background-color': customer_sub_type?.sub_type_color?.rgba_value }">
          <span class="customer-sub-type-name">> {{ customer_sub_type.name }}</span>
          <span v-if="subTypes(customer_type).length > 1">+</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerTypesTable',
  props: {
    customerTypes: {
      type: Array,
      default() {
        return [];
      }
    },
    customerSubTypes: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    subTypes(type) {
      return this.customerSubTypes.filter((subType) => subType?.type_id == type.id);
    }
  }
}
</script>

<style scoped>
  .customer-types-container {
    display: grid;
    grid-template-columns: 100px 100px 100px;
    grid-template-rows: 20px;
    row-gap: 3px;
    column-gap: 2px;
    margin-top: 10px;
    grid-auto-flow: column;
    min-height: 60px
  }
  .customer-type-container,
  .customer-sub-type-container {
    padding: 3px 4px;
    display: flex;
    justify-content: center;
    margin-right: 5px;
    margin-bottom: 4px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.05em;
    background-color: #F7F7F7;
    border: 1px solid #E5E5E5;
    white-space: nowrap;
  }
  .customer-type-name,
  .customer-sub-type-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>

